import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { ProblemStats } from "@/components/landing/ProblemStats";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { Features3Pillars } from "@/components/landing/Features3Pillars";
import { HowItWorksSteps } from "@/components/landing/HowItWorksSteps";
import { ProductPreview } from "@/components/landing/ProductPreview";
import { Testimonials } from "@/components/landing/Testimonials";
import { FAQAccordion } from "@/components/landing/FAQAccordion";
import { CTAFinal } from "@/components/landing/CTAFinal";
import { Footer } from "@/components/landing/Footer";

export function LandingPage() {
  const navigate = useNavigate();

  // Supabase recovery redirect — preserved from previous implementation.
  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes("type=recovery") || hash.includes("access_token")) {
      navigate("/reset-password" + hash, { replace: true });
    }
  }, [navigate]);

  // Global scroll reveal — ported from the Claude Design handoff (landing-app
  // inline script). Observes every section's direct children and fades them in
  // with a staggered 60ms delay as they scroll into view.
  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (reduceMotion) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            (e.target as HTMLElement).classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" },
    );

    const timer = window.setTimeout(() => {
      const sections = document.querySelectorAll(".cy-frame section");
      sections.forEach((sec, idx) => {
        if (idx === 0) return; // skip hero
        const containers = sec.querySelectorAll(":scope > div");
        containers.forEach((c) => {
          Array.from(c.children).forEach((child, i) => {
            const el = child as HTMLElement;
            el.classList.add("cy-reveal");
            el.style.transitionDelay = i * 60 + "ms";
            io.observe(el);
          });
        });
      });
    }, 120);

    return () => {
      window.clearTimeout(timer);
      io.disconnect();
    };
  }, []);

  return (
    <div className="cy-frame" style={{ minHeight: "100vh" }}>
      <Navbar />
      <main>
        <Hero />
        <div id="problema">
          <ProblemStats />
        </div>
        <BeforeAfter />
        <div id="features">
          <Features3Pillars />
        </div>
        <HowItWorksSteps />
        <div id="preview">
          <ProductPreview />
        </div>
        <Testimonials />
        <FAQAccordion />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}
